{
  "normal": {
    "fire": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "siamesedragon": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "ignis": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "firetail": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "jujak": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "magnello": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "lava": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "taros": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "hell": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "popomo": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "afrit": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "patroa": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "dragonslayer": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "phoenix": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "enturas": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "aquadragon": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "frog": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "sharkgon": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "swamp": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "rupia": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "poisonriver": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "frost": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "hyeonmu": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "tiamat": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "paruparu": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "wind": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "zephyros": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "typhoondragon": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "liberte": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "pinkbell": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "blue": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "sixleghorn": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "applecheek": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "beleth": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "totemdragon": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "plumos": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "iron": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "knightdragon": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "sharptail": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "dragonoid": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "blackarmor": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "fat": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "obex": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "rock": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "mustardhammer": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "egg": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "mushroom": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "lakion": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "leafdragon": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "scorpiondragon": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "mud": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "tumpy": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "power": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "bluethunder": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "whitethunder": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "bluelightning": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "taabire": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "thunderboltdragon": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "lightning": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "splender": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "bluefiretail": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "cloud": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "rafael": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "haze": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "emerald": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "ilios": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "spicy": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "dilrang": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "solar": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "selora": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "catsgon": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "lunera": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "serpentdragon": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "baal": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "ninjadragon": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "kleptos": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "skelegon": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "centipededragon": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "nox": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "witchdragon": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "lagtail": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "fides": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "liso": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "lambgon": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "goldie": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "nebula": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "henes": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "pierrotdragon": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "fairydragon": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "seere": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "cupid": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "alien": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "crevasse": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "goblindragon": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "slimedragon": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "mistdragon": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "mummydragon": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "gripo": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "dreaden": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "lucio": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "centura": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "angeljr": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "toddletomtom": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "florea": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "whitedragon": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "aila": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "characen": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "non": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "blackdragon": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "goddragon": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "granos": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "darknix": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "shadow": [
      "hatch",
      "hatchling",
      "adult"
    ]
  },
  "chroma": {
    "phoenix": [
      "hatch",
      "hatchling",
      "adult"
    ]
  },
  "chromaIcons": {
    "fire": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "siamesedragon": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "ignis": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "firetail": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "magnello": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "lava": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "taros": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "hell": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "popomo": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "afrit": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "phoenix": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "aquadragon": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "frog": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "sharkgon": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "swamp": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "rupia": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "poisonriver": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "hyeonmu": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "wind": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "zephyros": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "typhoondragon": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "pinkbell": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "blue": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "sixleghorn": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "applecheek": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "plumos": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "iron": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "knightdragon": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "sharptail": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "dragonoid": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "blackarmor": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "fat": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "rock": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "mustardhammer": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "egg": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "mushroom": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "lakion": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "leafdragon": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "scorpiondragon": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "mud": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "tumpy": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "power": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "whitethunder": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "bluelightning": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "taabire": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "thunderboltdragon": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "lightning": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "cloud": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "rafael": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "haze": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "emerald": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "ilios": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "spicy": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "catsgon": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "lunera": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "serpentdragon": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "baal": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "ninjadragon": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "kleptos": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "skelegon": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "centipededragon": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "nox": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "goldie": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "nebula": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "henes": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "pierrotdragon": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "fairydragon": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "cupid": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "alien": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "goblindragon": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "slimedragon": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "mistdragon": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "mummydragon": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "gripo": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "dreaden": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "whitedragon": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "blackdragon": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "darknix": [
      "hatch",
      "hatchling",
      "adult"
    ],
    "shadow": [
      "hatch",
      "hatchling",
      "adult"
    ]
  }
}
